import { Box, Button, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from '../../hooks/useTranslation';

function AddNewButton(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const isDisabled = !props?.isActiveFlag;
	const accentColor =
		props.customDetails?.primaryColor ?? theme.palette.primary.main;
	const borderColor = isDisabled
		? theme.palette.action.disabled
		: accentColor;

	return (
		<Box
			display="flex"
			alignItems="center"
			sx={{ ...(props?.buttonStyles ?? {}) }}
		>
			<Button
				type="button"
				disabled={isDisabled}
				variant="outlined"
				size="medium"
				startIcon={
					props.startIcon ?? <AddIcon sx={{ fontSize: '14px' }} />
				}
				sx={{
					ml: '4px',
					height: '35px',
					minHeight: '35px',
					fontSize: '12px',
					fontWeight: 500,
					lineHeight: 1,
					textTransform: 'uppercase',
					fontFamily: props.customDetails?.fontFamily,
					borderRadius: props.customDetails?.borderRadius || '6px',
					border: `1px solid ${borderColor}`,
					color: borderColor,
					backgroundColor: 'transparent',
					padding: '6px 8px',
					minWidth: 'unset',
					boxShadow: 'none',
					'& .MuiButton-startIcon': {
						marginRight: '2px',
						marginLeft: 0,
						color: 'inherit',
						'& .MuiSvgIcon-root': {
							fontSize: '14px',
						},
					},
					'&:hover': {
						backgroundColor: 'rgba(0, 0, 0, 0.04)',
						borderColor: borderColor,
						color: borderColor,
						boxShadow: 'none',
					},
					'&.Mui-disabled': {
						borderColor: theme.palette.action.disabledBackground,
						color: theme.palette.action.disabled,
					},
				}}
				onClick={props.handleAddAccount}
			>
				{t('common.buttons.addNew')}
			</Button>
		</Box>
	);
}

export default AddNewButton;
